import React from "react";
import "../../../../../../src/css/FinancialPromotions/Components/Buttons/StatusTag.css";

const StatusTag = ({ status }) => {
  // Normalize status for className and display
  const normalized = (status || "").toLowerCase().replace(/\s+/g, "-");
  const isUnknownStatus = normalized === "unknown" || normalized === "unklnow";
  const statusClass = isUnknownStatus ? "awaiting-response" : normalized;
  const displayStatus = isUnknownStatus ? "Awaiting Response" : status;
  return (
    <span
      className={`status-tag status-tag--${statusClass} FP_Content_Semibold`}
    >
      {displayStatus}
    </span>
  );
};

export default StatusTag;
